"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var react_select_1 = require("react-select");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var actions = require("@caddigital/sok-reducers/lib/actions/project/wizard");
var Types = require("types");
require("./CreateEditBillingInformation.scss");
var mapStateToProps = function (state) {
    return {
        billingInformations: state.project.wizard.billingInformations
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    toggleBillingInformationModal: function () {
        dispatch(actions.clearBillingInformationModal());
    },
    fetchCustomer: function (search) {
        return search.length > 2 &&
            dispatch(actions.searchBillingInformationRequest({ search: search, type: 'customer' }));
    },
    fetchProject: function (search, customerId) {
        return search.length > 2 &&
            dispatch(actions.searchBillingInformationRequest({
                search: search,
                type: 'project',
                customerId: customerId
            }));
    },
    selectCustomer: function (customer) {
        return dispatch(actions.selectBillingInformationCustomer(customer));
    },
    selectProject: function (projects) {
        return dispatch(actions.selectBillingInformationProject(projects));
    },
    apply: function (customer) { return (dispatch(actions.setBillingInformations(customer)),
        dispatch(actions.clearBillingInformationModal())); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
//#region Types
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
//#endregion
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentWillUnmount: function () {
        // Clear states
    }
}), recompose_1.pure);
exports.default = enhance(function (props) { return (React.createElement(sok_ui_1.Modal, { isOpen: props.billingInformations.isOpen, className: 'create-edit-billing-information-modal' },
    React.createElement(sok_ui_1.Header, { onClose: function () { return props.toggleBillingInformationModal(); } }, (0, translation_1.getLocalization)('admin/projectsTab/editProject/basicInformation/createEditBillingInformations/title')),
    React.createElement(sok_ui_1.Container, null,
        React.createElement("div", { className: 'content' },
            React.createElement("p", null, (0, translation_1.getLocalization)('admin/projectsTab/editProject/basicInformation/createEditBillingInformations/description')),
            React.createElement("div", { className: 'payment-selectors' },
                React.createElement(react_select_1.default, { classNamePrefix: "react-select", placeholder: (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/customer'), menuPlacement: 'auto', options: props.billingInformations.customers, isMulti: false, isLoading: props.billingInformations.fetchingCustomerStatus === 'FETCHING', getOptionLabel: function (opt) {
                        return opt.type === 'CUSTOM'
                            ? opt.customerName
                            : "".concat(opt.customerNumber, ": ").concat(opt.customerName);
                    }, value: props.billingInformations.selectedCustomer, getOptionValue: function (opt) { return opt.customerNumber; }, onChange: function (val) {
                        if (val) {
                            props.selectCustomer(val);
                        }
                    }, onInputChange: function (val) {
                        props.fetchCustomer(val);
                    } }),
                React.createElement(react_select_1.default, { classNamePrefix: "react-select", placeholder: (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/project'), isDisabled: props.billingInformations.selectedCustomer === undefined, options: props.billingInformations.projects, menuPlacement: 'auto', isMulti: true, isLoading: props.billingInformations.fetchingProjectStatus === 'FETCHING', getOptionLabel: function (opt) {
                        return "".concat(opt.projectNumber, ": ").concat(opt.projectName);
                    }, getOptionValue: function (opt) { return opt.projectNumber; }, value: (props.billingInformations.selectedCustomer &&
                        props.billingInformations.selectedCustomer.type ===
                            'INTERNAL' &&
                        props.billingInformations.selectedCustomer.projects) ||
                        [], onChange: function (val) {
                        if (val) {
                            props.selectProject(val);
                        }
                    }, onInputChange: function (val) {
                        if (props.billingInformations.selectedCustomer !== undefined &&
                            props.billingInformations.selectedCustomer.type === 'INTERNAL') {
                            props.fetchProject(val, props.billingInformations.selectedCustomer.customerNumber);
                        }
                    } })))),
    React.createElement(sok_ui_1.Footer, null,
        React.createElement(sok_ui_1.Button, { color: 'green', text: (0, translation_1.getLocalization)('admin/projectsTab/editProject/basicInformation/createEditBillingInformations/save'), onClick: function () {
                return props.billingInformations.selectedCustomer &&
                    props.apply(props.billingInformations.selectedCustomer);
            } }),
        React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('admin/projectsTab/editProject/basicInformation/createEditBillingInformations/cancel'), onClick: function () { return props.toggleBillingInformationModal(); } })))); });
